/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Fallback_MessageInputs */

const en_error_fallback_message = /** @type {(inputs: Error_Fallback_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

const pl_error_fallback_message = /** @type {(inputs: Error_Fallback_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Error_Fallback_MessageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_fallback_message = /** @type {((inputs?: Error_Fallback_MessageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Fallback_MessageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_error_fallback_message(inputs)
	return en_error_fallback_message(inputs)
});